// import getConfig from '@config';
import { getObjConfig } from '@webapp-next/lib/session';
import getLocationTz from '@webapp-next/modules/schedule/facades/get-location-tz';

export function getWorkplaces() {
  return getObjConfig()?.MySetup.WorkplaceConfig;
}

export function getDeprecatedTimezones() {
  return getObjConfig()?.DeprecatedTimezones;
}
/**
 * Get a valid timezone for the employee's workplace.
 * If the timezone is deprecated, use a valid replacement,
 * otherwise, use the default.
 *
 * @param {integer} employeeCompanyId
 * @return {string}
 */
export function getTimezone(employeeCompanyId) {
  // TODO: watch to make sure that getLocationTz is same as commented code.
  // difference is default timezone comes from env
  return getLocationTz(employeeCompanyId);

  // const { DEFAULT_TIMEZONE } = getConfig();
  // let timezone = DEFAULT_TIMEZONE;
  // const workplaces = getWorkplaces();
  // const deprecatedTimezones = getDeprecatedTimezones();

  // if (workplaces && workplaces[employeeCompanyId]) {
  //   timezone = workplaces[employeeCompanyId].TIMEZONE;
  // }

  // if (deprecatedTimezones && timezone in deprecatedTimezones) {
  //   timezone = deprecatedTimezones[timezone];
  // }

  // return timezone;
}
